/* VERY SIMPLE (BASED-style) — theme.js (no dependencies) */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var menu = $('[data-mobile-menu]');
    if (!menu) return;
    var open = menu.hasAttribute('hidden');
    if (open) menu.removeAttribute('hidden'); else menu.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Category tabs (home) ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (!tab) return;
    var root = tab.closest('[data-tabs]');
    if (!root) return;
    $$('[data-tab]', root).forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$('[data-tabpanel]', root).forEach(function (p) {
      p.hidden = p.getAttribute('data-tabpanel') !== tab.getAttribute('data-tab');
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = function () { return $('[data-cart-drawer]'); };

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var panel = $('.drawer__panel', d);
    if (panel) panel.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function renderDrawer() {
    return fetch(T.routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
        var fresh = $('[data-cart-drawer-inner]', doc);
        var current = $('[data-cart-drawer-inner]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
        }
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && T.cartType === 'drawer' && drawer()) {
      e.preventDefault();
      renderDrawer().then(openDrawer, openDrawer);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      closeDrawer();
      return;
    }
    var change = e.target.closest('[data-cart-change]');
    if (change) {
      e.preventDefault();
      fetch(T.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(change.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(change.getAttribute('data-qty'), 10)) })
      }).then(renderDrawer);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Add to cart (ajax) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    if (T.cartType !== 'drawer' || !drawer()) return; // normal submit -> cart page
    e.preventDefault();

    var buttons = $$('[data-add-to-cart]').filter(function (b) {
      return b.form === form || form.contains(b);
    });
    var errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.setAttribute('hidden', '');
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.classList.add('is-disabled'); });

    fetch(T.routes.cartAdd, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.json && (res.json.description || res.json.message)) || T.strings.error;
          if (errorEl) { errorEl.textContent = msg; errorEl.removeAttribute('hidden'); }
          return;
        }
        return renderDrawer().then(openDrawer);
      })
      .catch(function () {
        if (errorEl) { errorEl.textContent = T.strings.error; errorEl.removeAttribute('hidden'); }
      })
      .then(function () {
        buttons.forEach(function (b) { b.removeAttribute('aria-busy'); b.classList.remove('is-disabled'); });
      });
  });

  /* ---------- Quantity steppers (product form) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = btn.hasAttribute('data-qty-plus') ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });

  /* ---------- Product card variant select: update price ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-card-variant]');
    if (!sel) return;
    var card = sel.closest('.card');
    var price = card && $('[data-card-price]', card);
    var opt = sel.options[sel.selectedIndex];
    if (price && opt && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
    var compare = card && $('[data-card-compare]', card);
    if (compare) compare.hidden = true;
  });

  /* ---------- Collection toolbar: auto-submit sort ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target.closest && e.target.closest('[data-auto-submit]');
    if (el && el.form) el.form.submit();
  });

  /* ---------- Product: variants, gallery, sticky bar ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = $('form[data-type="add-to-cart-form"]', root);
    var idInput = form && $('[data-variant-id]', form);
    var fieldsets = $$('[data-option]', root);

    function selectedValues() {
      return fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function currentVariant() {
      var sel = selectedValues();
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }

    function updateButtons(variant) {
      $$('[data-add-to-cart]', root).forEach(function (b) {
        var label = $('[data-atc-label]', b);
        if (!variant) {
          b.disabled = true;
          if (label) label.textContent = T.strings.unavailable;
        } else if (!variant.available) {
          b.disabled = true;
          if (label) label.textContent = T.strings.soldOut;
        } else {
          b.disabled = false;
          if (label) label.textContent = T.strings.addToCart;
        }
      });
    }

    function goToMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var el = $('[data-media-id="' + variant.featured_media.id + '"]', root);
      var track = $('[data-gallery-track]', root);
      if (el && track) track.scrollTo({ left: el.offsetLeft, behavior: 'smooth' });
    }

    function onChange() {
      var variant = currentVariant();
      fieldsets.forEach(function (fs) {
        var checked = $('input:checked', fs);
        var label = $('[data-option-selected]', fs);
        if (checked && label) label.textContent = checked.value;
      });
      if (variant) {
        if (idInput) idInput.value = variant.id;
        $$('[data-price-variant]', root).forEach(function (el) {
          el.hidden = el.getAttribute('data-price-variant') !== String(variant.id);
        });
        var sticky = $('[data-sticky-price]', root);
        var priceEl = $('[data-price-variant="' + variant.id + '"] .price__now', root);
        if (sticky && priceEl) sticky.textContent = priceEl.textContent.replace(/\s+/g, ' ').trim();
        if (root.classList.contains('product') && window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
        goToMedia(variant);
      }
      updateButtons(variant);
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', onChange); });
  }

  function initGallery(g) {
    var track = $('[data-gallery-track]', g);
    if (!track) return;
    var items = $$('.gallery__item', track);
    var thumbs = $$('[data-thumb]', g);
    var count = $('[data-gallery-count]', g);
    var total = items.length;

    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      i = Math.max(0, Math.min(total - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    track.addEventListener('scroll', function () {
      var i = index();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (count) count.textContent = (i + 1) + ' / ' + total;
    }, { passive: true });
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) { go(parseInt(t.getAttribute('data-thumb'), 10)); return; }
      if (e.target.closest('[data-gallery-prev]')) go(index() - 1);
      if (e.target.closest('[data-gallery-next]')) go(index() + 1);
    });
  }

  function initStickyBar(root) {
    var sticky = $('[data-sticky-atc]', root);
    var mainBtn = sticky && $('.product__info [data-add-to-cart]', root);
    if (!sticky || !mainBtn || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', out);
      sticky.setAttribute('aria-hidden', out ? 'false' : 'true');
      var b = $('[data-add-to-cart]', sticky);
      if (b) b.tabIndex = out ? 0 : -1;
    });
    io.observe(mainBtn);
  }

  /* ---------- Related products (Shopify recommendations) ---------- */
  function initRelated(el) {
    var url = el.getAttribute('data-url');
    if (!url || el.querySelector('section')) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-related]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function boot(scope) {
    $$('[data-product-root]', scope).forEach(initProduct);
    $$('[data-gallery]', scope).forEach(initGallery);
    $$('[data-product-root]', scope).forEach(initStickyBar);
    $$('[data-related]', scope).forEach(initRelated);
  }
  boot(document);

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
